import { render } from "./operations.vue?vue&type=template&id=290b2251"
import script from "./operations.vue?vue&type=script&lang=js"
export * from "./operations.vue?vue&type=script&lang=js"

import "./operations.vue?vue&type=style&index=0&id=290b2251&lang=scss"

import exportComponent from "/Users/a/Documents/work/new/prnew/lk-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__